import React from 'react';

function getWeekNumber(date) {
  const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
  d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
  const yearStart = new Date(Date.UTC(d.getUTCFullYear(),0,1));
  const weekNo = Math.ceil((((d - yearStart) / 86400000) + 1)/7);
  return weekNo;
}

const TOTAL_WEEKS = 52;

const Drainer = () => {
    const currentWeek = getWeekNumber(new Date());
  
    return (
      <div
        style={{
          height: '100vh',
          background: 'black',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <div
            style={{
              color: 'white',
              marginBottom: '32px',
              fontSize: '1.2rem',
              textAlign: 'center',
              maxWidth: '320px',
              lineHeight: 1.4,
            }}
          >
            Each block represents a week of the year.<br />
            The black blocks show weeks that have passed; the white blocks are weeks remaining. Use them wisely.
          </div>
          <div
            style={{
              height: '80vh',
              width: '80px',
              display: 'flex',
              flexDirection: 'column',
              boxShadow: '0 0 8px rgba(0,0,0,0.3)',
              borderRadius: '12px',
              overflow: 'hidden',
              background: 'white',
            }}
          >
            {[...Array(TOTAL_WEEKS)].map((_, i) => (
              <div
                key={i}
                style={{
                  flex: 1,
                  background: i < currentWeek ? 'black' : 'white',
                  borderBottom: i !== TOTAL_WEEKS - 1 ? '1px solid #eee' : 'none',
                  transition: 'background 0.3s',
                }}
                title={`Week ${i + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    );
  };
  
  export default Drainer;